module.exports = __webpack_public_path__ + "img/upload_video.c2390a4e.png";